'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _DeleteOutlined = _interopRequireDefault(require('./lib/icons/DeleteOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _DeleteOutlined;
exports.default = _default;
module.exports = _default;